import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ROUTE_PATHS } from '@/lib/index';
import { productsData } from '@/data/index';
import { ProductCard } from '@/components/Cards';
import { IMAGES } from '@/assets/images';

export default function Products() {
  return (
    <div className="min-h-screen bg-background">
      <section className="relative py-24">
        <div className="absolute inset-0 z-0">
          <img
            src={IMAGES.FACTORY_2}
            alt="工厂背景"
            className="w-full h-full object-cover opacity-10"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/60 to-background" />
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <div className="flex items-center justify-center gap-3 mb-4">
              <div className="h-px w-12 bg-primary" />
              <span className="font-mono text-xs font-bold tracking-widest uppercase text-primary">
                PRODUCT LINES
              </span>
              <div className="h-px w-12 bg-primary" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              产品系列
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              六大核心橡胶品种，FKM / EPDM / NBR / NR / CR / ESD，覆盖化工、建筑、矿山等工业场景
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16"
          >
            {productsData.map((product, index) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.1 * index }}
              >
                <ProductCard product={product} />
              </motion.div>
            ))}
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="card-industrial p-8 border-primary/30"
          >
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="text-center md:text-left">
                <h3 className="text-2xl font-bold mb-2">
                  没有找到合适的型号？
                </h3>
                <p className="text-muted-foreground">
                  我们提供定制配方服务，请联系技术团队获取专业建议
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 shrink-0">
                <Link to={ROUTE_PATHS.CONTACT}>
                  <button className="btn-primary-industrial px-6 py-3 rounded-md whitespace-nowrap">
                    联系技术团队
                  </button>
                </Link>
                <Link to={ROUTE_PATHS.SELECTION}>
                  <button className="btn-outline-industrial px-6 py-3 rounded-md whitespace-nowrap">
                    查看选型指南
                  </button>
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
